// extracted by mini-css-extract-plugin
module.exports = {"wrapperChat":"BtnChat_wrapperChat__3fi3K","chatBtn":"BtnChat_chatBtn__2Qwj4"};